import { useState } from "react";
import { toast } from "sonner";
import { MailCheck } from "lucide-react";
import { api, errMsg, fmtDate } from "@/lib/api";

export const ResendEmailButton = ({ r, onSent, testId }) => {
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try {
      const res = await api.post(`/transactions/${r.id}/resend-confirmation`);
      toast.success(`Registration email resent to ${res.data.email}`);
      onSent?.();
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <button type="button" onClick={go} disabled={busy} title={r.confirmation_resent_at ? `Last resent ${fmtDate(r.confirmation_resent_at)}` : "Resend the registration email"}
      className="text-xs font-semibold text-sky-700 hover:underline inline-flex items-center gap-1 disabled:opacity-50" data-testid={testId || `evreg-resend-email-${r.ticket_no}`}>
      <MailCheck className="w-3.5 h-3.5" />{busy ? "Sending…" : "Resend email"}
    </button>
  );
};
